<app-page-container [padded]="false" [navbarOverlay]="true">
  <app-home-hero (ctaClick)="scrollToPlanTrip()" />
  <app-home-why-choose />
  <app-home-explore-themes />
  <app-home-most-loved />
  <app-home-partners />
  <app-home-trusted />
  <div #planTripAnchor id="plan-trip" class="scroll-mt-24">
    @defer (when showPlanTrip(); on idle) {
      <app-plan-trip />
    } @placeholder {
      <div class="min-h-[32rem]"></div>
    } @loading {
      <div class="min-h-[32rem] animate-pulse rounded-2xl bg-slate-100"></div>
    }
  </div>
</app-page-container>
